import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Clock, Building2, IndianRupee, TrendingUp, ArrowRight } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { STREAMS } from '../data/mock';
import { fetchCourses } from '../lib/api';

const STREAM_COLOR = STREAMS.reduce((acc, s) => ({ ...acc, [s.key]: s.color }), {});

const Courses = () => {
  const [courses, setCourses] = useState([]);
  useEffect(() => {
    fetchCourses().then(setCourses).catch(() => setCourses([]));
  }, []);
  return (
    <div className="bg-slate-50 min-h-screen">
      <div className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <h1 className="text-3xl md:text-4xl font-bold text-slate-900" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Courses in India</h1>
          <p className="text-slate-600 mt-1">Explore undergraduate and postgraduate programs across streams.</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {courses.map((c) => (
          <Link key={c.id} to={`/courses/${c.slug || c.id}`} className="group bg-white rounded-2xl border border-slate-200 p-6 card-lift">
            <div className={`inline-flex text-xs font-semibold px-3 py-1 rounded-full ${STREAM_COLOR[c.stream] || 'bg-slate-100 text-slate-700'}`}>
              {STREAMS.find((s) => s.key === c.stream)?.label}
            </div>
            <h3 className="font-bold text-2xl text-slate-900 mt-3 group-hover:text-teal-700 transition-colors" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{c.name}</h3>
            <div className="text-sm text-slate-500">{c.full}</div>
            <p className="text-sm text-slate-600 mt-3 line-clamp-2">{c.description}</p>

            <div className="grid grid-cols-2 gap-3 mt-4 text-xs">
              <div className="flex items-center gap-2 text-slate-600"><Clock className="w-3.5 h-3.5 text-teal-600" /> {c.duration}</div>
              <div className="flex items-center gap-2 text-slate-600"><Building2 className="w-3.5 h-3.5 text-teal-600" /> {c.colleges}+ colleges</div>
              <div className="flex items-center gap-2 text-slate-600"><IndianRupee className="w-3.5 h-3.5 text-teal-600" /> {c.avgFees}</div>
              <div className="flex items-center gap-2 text-slate-600"><TrendingUp className="w-3.5 h-3.5 text-teal-600" /> {c.avgSalary}</div>
            </div>

            <div className="mt-5 pt-4 border-t border-slate-100 flex items-center justify-between">
              <Badge className="bg-teal-50 text-teal-700 hover:bg-teal-50 border-teal-200">Popular</Badge>
              <span className="text-sm font-semibold text-teal-700 group-hover:text-orange-600 inline-flex items-center gap-1">See colleges <ArrowRight className="w-3.5 h-3.5" /></span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Courses;
